"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var Widget_1 = require("../tools/Widget");
var jquery_1 = __importDefault(require("jquery"));
var Pikaday = __importStar(require("../lib/pikaday"));
var dateInputSupported = (function () {
    var el = document.createElement("input");
    el.setAttribute("type", "date");
    return el.type == 'date';
}());
var ARROW_LEFT = 37;
var ARROW_RIGHT = 39;
var ARROW_UP = 38;
var ARROW_DOWN = 40;
var TAB = 9;
var ENTER = 13;
var BACKSPACE = 8;
var DELETE = 46;
var YEAR_MONTH_DAY = /^\d{1,4}-\d{1,2}-\d{1,2}$/;
var MOD = {
    DAY: 0,
    MONTH: 1,
    YEAR: 2,
    NOTHING: 3
};
var RANGES = [
    { start: 0, ammount: 2 },
    { start: 3, ammount: 2 },
    { start: 6, ammount: 4 },
    { start: 0, ammount: 0 }
];
var DateInputPolyfill = (function (_super) {
    __extends(DateInputPolyfill, _super);
    function DateInputPolyfill() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.modifying = MOD.NOTHING;
        _this.inputValue = '';
        return _this;
    }
    DateInputPolyfill.prototype.init = function () {
        if (dateInputSupported) {
            return;
        }
        this.display = ['dd', 'mm', 'jjjj'];
        var openHandler = jquery_1.default.proxy(this.dpOpen, this);
        var selectHandler = jquery_1.default.proxy(this.dpSelect, this);
        var closeHandler = jquery_1.default.proxy(this.reset, this);
        var date = this.getDate();
        this.el.hide();
        this.createProxyInput();
        this.datepicker = new Pikaday({
            field: this.proxyInput[0],
            onSelect: selectHandler,
            onOpen: openHandler,
            onClose: closeHandler
        });
        this.setDate(date);
        this.renderDisplay();
    };
    DateInputPolyfill.setDateInputSupported = function (value) {
        dateInputSupported = value;
    };
    DateInputPolyfill.prototype.createProxyInput = function () {
        this.proxyInput = jquery_1.default('<input type="date" />');
        this.proxyInput.attr("class", this.el.attr("class"));
        this.proxyInput.insertAfter(this.el);
        this.proxyInput.on('focus', jquery_1.default.proxy(this.handleClickAndFocus, this));
        this.proxyInput.on('keydown', jquery_1.default.proxy(this.handleKeydown, this));
        this.proxyInput.on('keypress', jquery_1.default.proxy(this.handleKeypress, this));
        this.proxyInput.on('keyup', jquery_1.default.proxy(this.handleKeyup, this));
        this.proxyInput.on('click', jquery_1.default.proxy(this.handleClickAndFocus, this));
        this.proxyInput.on('input', jquery_1.default.proxy(this.handleClear, this));
    };
    DateInputPolyfill.prototype.handleClear = function () {
        if (!this.proxyInput.val()) {
            this.display = ['dd', 'mm', 'jjjj'];
            this.reset();
            this.setDate(null);
        }
        this.renderDisplay();
    };
    DateInputPolyfill.prototype.handleClickAndFocus = function () {
        if (this.getSelectionLength() <= 4) {
            this.expandSelection();
        }
        else {
            this.setSelection(0, 10);
        }
        this.inputValue = '';
    };
    DateInputPolyfill.prototype.handleKeydown = function (event) {
        if (event.which === ENTER) {
            event.preventDefault();
            this.blur();
        }
        if (event.which === TAB) {
            event.preventDefault();
            this.move(event.shiftKey ? -1 : 1);
        }
        if (event.which === BACKSPACE || event.which === DELETE) {
            event.preventDefault();
            this.handleDelete();
        }
        this.renderDisplay();
        this.select(this.modifying);
    };
    DateInputPolyfill.prototype.handleKeypress = function (event) {
        event.preventDefault();
        var char = String.fromCharCode(event.which);
        if (/^[0-9]$/.test(char)) {
            this.handleInput(char);
        }
        this.renderDisplay();
        this.select(this.modifying);
    };
    DateInputPolyfill.prototype.handleKeyup = function (e) {
        e.preventDefault();
        switch (e.which) {
            case ARROW_RIGHT:
                this.move(1);
                break;
            case ARROW_LEFT:
                this.move(-1);
                break;
            case ARROW_UP:
                this.shiftDatePart(1);
                break;
            case ARROW_DOWN:
                this.shiftDatePart(-1);
                break;
        }
        this.renderDisplay();
        this.select(this.modifying);
    };
    DateInputPolyfill.prototype.handleInput = function (number) {
        var newInput = parseInt(this.inputValue + number, 10);
        if (!this.setDatePart(newInput)) {
            return;
        }
        if ((this.modifying !== MOD.YEAR && newInput.toString().length >= 2)
            || (this.modifying === MOD.YEAR && newInput.toString().length >= 4)) {
            this.inputValue = '';
        }
        else {
            this.inputValue = newInput;
        }
    };
    DateInputPolyfill.prototype.handleDelete = function () {
        var mod = this.modifying;
        if (this.getSelectionLength() > 4) {
            this.modifying = MOD.NOTHING;
            this.display = ['dd', 'mm', 'jjjj'];
            this.el.val('');
            this.renderDisplay();
        }
        else {
            this.setDatePart(mod === MOD.DAY ? 'dd' : mod === MOD.MONTH ? 'mm' : 'jjjj');
        }
        this.inputValue = '';
    };
    DateInputPolyfill.prototype.getSelectionLength = function () {
        var selectedLength, range;
        if ('selectionStart' in this.proxyInput[0]) {
            selectedLength = this.proxyInput[0].selectionEnd - this.proxyInput[0].selectionStart;
        }
        else if ('selection' in document) {
            range = document.selection.createRange();
            selectedLength = range.text.length;
        }
        return selectedLength;
    };
    DateInputPolyfill.prototype.blur = function () {
        var input = this.proxyInput;
        this.reset();
        this.select(MOD.NOTHING);
        setTimeout(function () {
            input.blur();
        }, 20);
    };
    DateInputPolyfill.prototype.move = function (direction) {
        this.modifying = this.modifying + direction;
        if (this.modifying < MOD.DAY) {
            this.modifying = MOD.YEAR;
        }
        else if (this.modifying > MOD.YEAR) {
            this.modifying = MOD.DAY;
        }
        this.select(this.modifying);
        this.inputValue = '';
    };
    DateInputPolyfill.prototype.shiftDatePart = function (modifier) {
        var display = this.display;
        var part = display[this.modifying];
        var maxDate = 31;
        var maxYear = new Date();
        maxYear = maxYear.getFullYear() + 50;
        display[this.modifying] = (isNaN(part) ? 0 : part) + modifier;
        if (!isNaN(display[1]) && !isNaN(display[2])) {
            maxDate = (new Date(display[2], display[1], 0)).getDate();
        }
        display[0] = (isNaN(display[0]) ? display[0] : display[0] < 1 ? maxDate : display[0]);
        display[1] = (isNaN(display[1]) ? display[1] : display[1] < 1 ? 12 : display[1]);
        display[2] = (isNaN(display[2]) ? display[2] : display[2] < 0 ? maxYear : display[2]);
        display[0] = (isNaN(display[0]) ? display[0] : display[0] > maxDate ? 1 : display[0]);
        display[1] = (isNaN(display[1]) ? display[1] : display[1] > 12 ? 1 : display[1]);
        display[2] = (isNaN(display[2]) ? display[2] : display[2] > maxYear ? 0 : display[2]);
        var date = this.displayToDate();
        if (date && !isNaN(date)) {
            this.sync(date);
        }
        else {
            this.setDate(date);
        }
        this.inputValue = '';
        this.select(this.modifying);
    };
    DateInputPolyfill.prototype.setDatePart = function (value) {
        var display = this.display;
        var maxDate = new Date(display[2], display[1], 0);
        var date;
        maxDate = isNaN(maxDate.getTime()) ? 31 : maxDate.getDate();
        if (!isNaN(value)
            && ((this.modifying === MOD.DAY && value > maxDate)
                || (this.modifying === MOD.MONTH && value > 12))) {
            return false;
        }
        this.display[this.modifying] = value;
        date = this.displayToDate();
        if (date && !isNaN(date)) {
            this.sync(date);
        }
        else {
            this.setDate(this.displayToDate());
        }
        this.select(this.modifying);
        return true;
    };
    DateInputPolyfill.prototype.displayToDate = function (display) {
        display = display || this.display;
        var date = new Date();
        var day = display[0];
        var month = display[1] - 1;
        var year = display[2];
        date.setFullYear(year);
        date.setDate(day);
        date.setMonth(month);
        date = isNaN(date) ? null : date;
        return date;
    };
    DateInputPolyfill.prototype.sync = function (date) {
        this.setDate(date);
        this.renderDisplay();
        if (!date || isNaN(date)) {
            return;
        }
        this.datepicker.setDate(date);
        this.datepicker.adjustPosition();
    };
    DateInputPolyfill.prototype.expandSelection = function () {
        var input = this.proxyInput[0];
        var caret = 0;
        if ('createTextRange' in input
            && 'selection' in document) {
            var range = document.selection.createRange();
            var textRange = this.proxyInput[0].createTextRange();
            var duplicate = textRange.duplicate();
            textRange.moveToBookmark(range.getBookmark());
            duplicate.setEndPoint('EndToStart', textRange);
            caret = range ? duplicate.text.length : 0;
        }
        else if ('selectionStart' in input) {
            caret = input.selectionStart;
        }
        if (caret < 3) {
            this.select(MOD.DAY);
        }
        else if (caret < 6) {
            this.select(MOD.MONTH);
        }
        else {
            this.select(MOD.YEAR);
        }
    };
    DateInputPolyfill.prototype.select = function (modifying) {
        this.modifying = modifying;
        this.setSelection(RANGES[modifying].start, RANGES[modifying].ammount);
    };
    DateInputPolyfill.prototype.setSelection = function (start, amount) {
        var input = this.proxyInput[0];
        if ('createTextRange' in input) {
            var textRange = this.proxyInput[0].createTextRange();
            textRange.moveStart("character", start);
            textRange.collapse();
            textRange.moveEnd("character", amount);
            textRange.select();
        }
        else if ('selectionStart' in input) {
            input.selectionStart = start;
            input.selectionEnd = start + amount;
        }
    };
    DateInputPolyfill.prototype.dpOpen = function () {
        this.sync(this.getDate());
    };
    DateInputPolyfill.prototype.dpSelect = function () {
        var date = this.datepicker.getDate();
        if (date) {
            this.setDate(date);
            this.renderDisplay();
        }
    };
    DateInputPolyfill.prototype.dpClose = function () {
        this.blur();
        this.reset();
    };
    DateInputPolyfill.prototype.reset = function () {
        this.modifying = MOD.NOTHING;
        this.inputValue = '';
    };
    DateInputPolyfill.prototype.renderDisplay = function () {
        var display = this.display;
        var day = isNaN(display[0]) ? display[0] : '00'.concat(display[0]).slice(-2);
        var month = isNaN(display[1]) ? display[1] : '00'.concat(display[1]).slice(-2);
        var year = isNaN(display[2]) ? display[2] : '0000'.concat(display[2]).slice(-4);
        this.proxyInput.val([day, month, year].join("-"));
    };
    DateInputPolyfill.prototype.setDate = function (date) {
        if (date && !isNaN(date)) {
            var day = date.getDate();
            var month = date.getMonth() + 1;
            var year = date.getFullYear();
            this.display = [day, month, year];
            this.el.val([year, month, day].join('-'));
        }
        else {
            this.el.val('');
        }
    };
    DateInputPolyfill.prototype.getDate = function () {
        var value = this.el.val().replace(/\s/g, "");
        var date = null;
        if (YEAR_MONTH_DAY.test(value)) {
            value = value.split('-');
            date = new Date();
            date.setFullYear(value[0]);
            date.setMonth(value[1] - 1);
            date.setDate(value[2]);
        }
        return date;
    };
    return DateInputPolyfill;
}(Widget_1.Widget));
exports.DateInputPolyfill = DateInputPolyfill;
